export default "__VITE_ASSET__iKbfiWnt__"